import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReceivings from '../reducers/receivings.reducer';

export const selectReceivingsState = createFeatureSelector<fromReceivings.State>(
  fromReceivings.receivingsFeatureKey
);

export const selectReceivingState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.receiving
);

export const selectReceivingsPathState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.receivingsPath
);

export const selectReceivingsFilterTypeState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.filterType
);

export const selectReceivingsIsLoadingState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.isLoading
);

export const selectReceivingsIsMaster = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.isMasterChecked
);


export const selectReceivingListState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.receivings
);

export const selectReceivingsFilterIDState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.filterID
);

export const selectReceivingsQueryState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.query
);

export const selectReceivingsSelectedState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.selected
);

export const selectReceivingsBarcodeState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.barcodes
);

export const selectReceivingsDuplicateBarcodeState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.duplicateBarcode
);

export const selectReceivingsSortState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.sortType
);

export const selectReceivingsDirectionState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => state.direction
);

export const selectReceivingPageState = createSelector(
  selectReceivingsState,
  (state: fromReceivings.State) => {
    state.direction
  }
);
